import React from 'react'

import { CircularProgress, styled } from '@mui/material'

const StyledProgress = styled(CircularProgress)(({ theme }) => ({
  display: 'block',
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3),
  color: theme.palette.primary.main,
}))

const Loading = () => <StyledProgress />

export default Loading
